import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Page-scoped "Registros por vencer" banner.
 *
 * Built locally because no ui-kit primitive covers title + count + a
 * "Ver registros" action + a close control together (`<ui-alert>` is
 * message-only, `<ui-card-banner>` has no CTA slot), and the two repo-local
 * banners are one-shot toast shapes, not a state-driven page banner.
 */
@Component({
  standalone: false,
  selector: 'digicem-due-soon-banner',
  templateUrl: './due-soon-banner.component.html',
})
export class DueSoonBannerComponent {
  @Input() soonToExpireCount = 0;

  @Output() viewRecords = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  protected get countLabel(): string {
    const unit =
      this.soonToExpireCount === 1
        ? 'registro próximo a vencer'
        : 'registros próximos a vencer';
    return `Tienes ${this.soonToExpireCount} ${unit}.`;
  }
}
